/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { CustomModal, DataList, Loader } from 'commons-ui';
import { useStyletron } from 'baseui';
import { Button, KIND, SIZE } from 'baseui/button';
import { LIST_ENTITY_NAMES } from 'constant';
import useLegalDetails from '../../utils/useLegalDetails';
import { columnConfigs } from './listConfig';

const LegalDetailsList: React.FC<{}> = () => {
	const { forceUpdate, showLoader, handleFilterModalOpen, getAllLegalDetailsData, handleDownloadLegalDetails } = useLegalDetails();
	const [css] = useStyletron();
	return (
		<>
			{showLoader && <Loader />}
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					borderTop: '1px solid rgb(242, 242, 242)',
					gap: '20px'
				})}>
				<Button
					kind={KIND.primary}
					size={SIZE.compact}
					onClick={() => {
						handleFilterModalOpen();
					}}>
					ChangeFilters
				</Button>
				<Button
					kind={KIND.primary}
					size={SIZE.compact}
					onClick={() => {
						handleDownloadLegalDetails();
					}}>
					Download Legal Details CSV
				</Button>
			</div>
			{/* add data list here */}
			<DataList
				fetchData={getAllLegalDetailsData}
				columnConfigs={columnConfigs}
				entity={LIST_ENTITY_NAMES.LEGAL_DETAILS}
				height='calc(100vh - 220px)'
				disablePagination
				showFooterMessage={false}
				filterable={false}
				globalForceUpdate={forceUpdate}
			/>
			<CustomModal />
		</>
	);
};

export default LegalDetailsList;
